/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TicketIntegrationNotesResponse } from '../../models/ticket-integration-notes-response';

export interface TicketControllerFindIntegrationNotes$Params {
  id: number;

/**
 * Sends 0 to remove limit
 */
  limit: number;
  skip: number;

/**
 * Testo contenuto nella nota
 */
  query?: string;

/**
 * Autore: nome, cognome o username (più parole = tutte presenti)
 */
  author?: string;

/**
 * true = solo sincronizzate, false = solo da sincronizzare
 */
  synced?: boolean;

/**
 * true = solo note provenienti da HDA
 */
  from_hda?: boolean;

/**
 * Note create dal (incluso)
 */
  created_from?: string;

/**
 * Note create fino al (incluso)
 */
  created_to?: string;
}

export function ticketControllerFindIntegrationNotes(http: HttpClient, rootUrl: string, params: TicketControllerFindIntegrationNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketIntegrationNotesResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, ticketControllerFindIntegrationNotes.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('query', params.query, {});
    rb.query('author', params.author, {});
    rb.query('synced', params.synced, {});
    rb.query('from_hda', params.from_hda, {});
    rb.query('created_from', params.created_from, {});
    rb.query('created_to', params.created_to, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TicketIntegrationNotesResponse;
      }>;
    })
  );
}

ticketControllerFindIntegrationNotes.PATH = '/ticket/{id}/integration-notes';
